<template>
  <div class="block block-cust">
    <img :src="bg" class="img-responsive img-bg" alt="" />
    <div class="main-position">
      <div class="container">
        <div class="main">
          <div class="animated" v-animate="'slideInLeft'">
            <div class="title title-cust">
              近百家客户群体 <span> 50 大中型上市企业客户 </span>
            </div>
            <div class="title2">
              为客户提供长期的可持续的信息化建设与服务，长期服务30家大型上市企业客户
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bg from "@/assets/images/case/bg.png";

export default {
  data() {
    return {
      bg,
    };
  },
};
</script>

<style scoped>
.block-cust {
  position: relative;
  padding: 0;
}
.main-position {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
}
.main {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-cust {
  font-size: 32px;
  text-align: left;
}
.title-cust span {
  color: #f6c946;
}
.title2 {
  font-size: 16px;
  color: #ccc;
}
.img-bg {
  min-height: 300px;
}

/*  */
.mb .title-cust {
  font-size: 20px;
}
.mb .title2 {
  font-size: 14px;
}
</style>